import React, { forwardRef, useEffect, useImperativeHandle, useRef,  } from 'react';
import Modal from './modal'
import { createRoot } from 'react-dom/client';

const Container = ({
  visible,
  onClose,
  onOverlayClick,
  content
}, ref) => {
  const container = useRef();

  const handleClose = () => {
    if (rootRef.current) {
      rootRef.current.unmount();
      rootRef.current = null;
    }
    if (container.current && container.current.parentNode) {
      container.current.parentNode.removeChild(container.current);
    }
    container.current = null;
  }

  const rootRef = useRef(null);

  const render = () => {
    if (!rootRef.current) {
      rootRef.current = createRoot(container.current);
    }
    rootRef.current.render(
      <Modal
        onClose={onClose}
        onOverlayClick={onOverlayClick}
        content={content}
      />
    )
  }

  const handleShow = () => {
    container.current = document.createElement('div');
    document.body.appendChild(container.current);
    render()
  }

  useImperativeHandle(ref, () => {
    return {
      refresh() {
        render()
      }
    }
  })

  useEffect(() => {
    if (visible) {
      handleShow();
    } else {
      handleClose()
      // onClose && onClose();
    }
    return () => {
      handleClose();
    }
  }, [visible])

  return null;
}

export default React.memo(forwardRef(Container))
